/* Critical: lille, afhængighedsfri JS til skuffer, kurv, pakkevalg og galleri. */
(() => {
  const $ = (s, el = document) => el.querySelector(s);
  const $$ = (s, el = document) => Array.from(el.querySelectorAll(s));
  const routes = Object.assign({ cartAdd: '/cart/add.js', cartChange: '/cart/change.js', cartUpdate: '/cart/update.js', cart: '/cart', root: '/' }, (window.Critical && window.Critical.routes) || {});
  const CART_SECTION = 'c-cart-drawer';

  /* ---------- skuffer ---------- */
  let lastFocus = null;
  function openDrawer(id) {
    const d = document.getElementById(id);
    if (!d) return false;
    lastFocus = document.activeElement;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('c-lock');
    $$(`[aria-controls="${id}"]`).forEach((b) => b.setAttribute('aria-expanded', 'true'));
    const f = $('[data-c-close]:not(.c-drawer__overlay)', d);
    if (f) setTimeout(() => f.focus(), 50);
    return true;
  }
  function closeDrawer(d) {
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    if (!$('.c-drawer.is-open')) document.documentElement.classList.remove('c-lock');
    $$(`[aria-controls="${d.id}"]`).forEach((b) => b.setAttribute('aria-expanded', 'false'));
    if (lastFocus) lastFocus.focus();
  }
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-c-open]');
    if (opener) {
      if (opener.dataset.cOpen === 'c-cart' && document.body.classList.contains('c-tpl-cart')) return;
      if (openDrawer(opener.dataset.cOpen)) e.preventDefault();
      return;
    }
    const closer = e.target.closest('[data-c-close]');
    if (closer) closeDrawer(closer.closest('[data-c-drawer]'));
  });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    const d = $('.c-drawer.is-open');
    if (d) closeDrawer(d);
  });

  /* ---------- kurv ---------- */
  function renderCart(sections, open) {
    const html = sections && sections[CART_SECTION];
    if (!html) return;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fresh = $('[data-c-cart-inner]', doc);
    const current = $('#c-cart [data-c-cart-inner]');
    // gavehilsenen må ikke forsvinde, når kurven tegnes igen
    const oldNote = current && $('textarea[name="note"]', current);
    const newNote = fresh && $('textarea[name="note"]', fresh);
    if (oldNote && newNote) { newNote.value = oldNote.value; if (oldNote.value) newNote.closest('details') && newNote.closest('details').setAttribute('open', ''); }
    if (fresh && current) current.replaceWith(fresh);
    const count = fresh ? Number(fresh.dataset.count || 0) : 0;
    $$('[data-c-cart-count]').forEach((el) => { el.textContent = count; el.hidden = count === 0; });
    $$('[data-c-cart-link]').forEach((el) => el.setAttribute('aria-label', 'Kurv, ' + count + (count === 1 ? ' vare' : ' varer')));
    const total = fresh ? Number(fresh.dataset.total || 0) : 0;
    $$('[data-c-ship-left]').forEach((el) => {
      const left = Number(el.dataset.threshold) - total;
      const kr = (n) => (n / 100).toLocaleString('da-DK', { maximumFractionDigits: 2 }) + ' kr';
      if (count > 0) { el.dataset.cart = total; el.textContent = left > 0 ? 'Du mangler ' + kr(left) + ' til gratis fragt.' : 'Din kurv har gratis fragt.'; el.hidden = false; }
    });
    document.dispatchEvent(new CustomEvent('c:cart-updated', { detail: { count } }));
    if (open) openDrawer('c-cart');
  }
  /* ---------- gavehilsen gemmes løbende som ordrenote ---------- */
  let noteTimer = null;
  let notePending = null;
  function saveNote() {
    clearTimeout(noteTimer);
    if (notePending === null) return Promise.resolve();
    const note = notePending;
    notePending = null;
    return fetch(routes.cartUpdate, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ note }) }).catch(() => {});
  }
  document.addEventListener('input', (e) => {
    const t = e.target.closest('textarea[name="note"]');
    if (!t) return;
    $$('textarea[name="note"]').forEach((o) => { if (o !== t) o.value = t.value; });
    notePending = t.value;
    clearTimeout(noteTimer);
    noteTimer = setTimeout(saveNote, 600);
  });

  const ERR_ADD = 'Varen kunne ikke lægges i kurven. Prøv igen.';
  const ERR_CART = 'Kurven kunne ikke opdateres. Prøv igen.';
  // fejl fra netværket eller et svar, der ikke er JSON, bliver til en dansk besked
  async function post(url, body) {
    let res, json;
    try {
      res = await fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
      json = await res.json();
    } catch (_) {
      throw { description: 'Der skete en fejl med forbindelsen. Prøv igen.' };
    }
    if (!res.ok) throw json;
    return json;
  }
  const errText = (err, fallback) => (err && typeof err.description === 'string' && err.description) || fallback;
  // beskeden placeres i forslagsboksen, hvis formularen ligger i en, så den kan brydes over flere linjer
  const errBox = (form) => form.closest('.c-swap, .c-ship__pick, .c-upsell__item, .c-addon') || form;
  function showError(form, msg) {
    const box = errBox(form);
    let el = $('[data-c-error]', box);
    if (!el) { el = document.createElement('p'); el.dataset.cError = ''; el.className = 'c-small c-accent c-form-err'; el.setAttribute('role', 'alert'); box.appendChild(el); }
    el.textContent = msg;
  }
  function clearErrors(form, bar) {
    const box = errBox(form);
    $$('[data-c-error]', box).forEach((el) => el.remove());
    if (bar) $$('[data-c-bar-error]', bar).forEach((el) => el.remove());
    const sticky = $('[data-c-sticky-buy]');
    if (sticky && form.id === 'ProductForm') $$('[data-c-bar-error]', sticky).forEach((el) => el.remove());
  }
  // fejl fra den svævende købsbjælke vises ved bjælken, så kunden kan se dem
  function showBarError(bar, msg) {
    let el = $('[data-c-bar-error]', bar);
    if (!el) { el = document.createElement('p'); el.dataset.cBarError = ''; el.className = 'c-sticky-buy__err'; el.setAttribute('role', 'alert'); bar.appendChild(el); }
    el.textContent = msg;
    clearTimeout(el._t);
    el._t = setTimeout(() => el.remove(), 6000);
  }
  // knapper til en formular, også dem uden for den (form="...")
  const formButtons = (form) => [...$$('[type="submit"]', form), ...(form.id ? $$('[type="submit"][form="' + form.id + '"]') : [])];
  function setBusy(form, btn, on) {
    if (on) form.dataset.busy = '1'; else delete form.dataset.busy;
    formButtons(form).forEach((b) => { b.disabled = on; });
    if (btn) btn.classList.toggle('is-loading', on);
  }
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[data-c-add]');
    if (!form) return;
    e.preventDefault();
    if (form.dataset.busy) return; // dobbelttryk lægger ikke varen i kurven to gange
    // knappen kan ligge uden for formularen (den svævende købsbjælke)
    const btn = e.submitter || $('[type="submit"]', form);
    const bar = btn && btn.closest('[data-c-sticky-buy]');
    clearErrors(form, bar);
    setBusy(form, btn, true);
    const fd = new FormData(form);
    try {
      await saveNote();
      const data = await post(routes.cartAdd, { items: [{ id: Number(fd.get('id')), quantity: Number(fd.get('quantity') || 1) }], sections: [CART_SECTION], sections_url: window.location.pathname });
      if (document.body.classList.contains('c-tpl-cart')) { window.location.reload(); return; }
      renderCart(data.sections, true);
    } catch (err) {
      const msg = errText(err, ERR_ADD);
      showError(form, msg);
      if (bar) showBarError(bar, msg);
    } finally {
      setBusy(form, btn, false);
    }
  });
  /* ---------- byt til pakke (3-pak eller træningssæt) ---------- */
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[data-c-swap]');
    if (!form) return;
    e.preventDefault();
    if (form.dataset.busy) return;
    const btn = $('[type="submit"]', form);
    clearErrors(form);
    setBusy(form, btn, true);
    try {
      await saveNote();
      const data = await post(routes.cartUpdate, { updates: JSON.parse(form.dataset.updates), sections: [CART_SECTION], sections_url: window.location.pathname });
      if (document.body.classList.contains('c-tpl-cart')) { window.location.reload(); return; }
      renderCart(data.sections, true);
    } catch (err) {
      showError(form, errText(err, ERR_CART));
    } finally {
      setBusy(form, btn, false);
    }
  });

  /* ---------- antal og fjern i kurven ---------- */
  // hent kurven igen, så antal og priser altid passer med det, Shopify har
  function refreshCart() {
    return fetch(routes.root + '?sections=' + CART_SECTION, { headers: { Accept: 'application/json' } })
      .then((res) => (res.ok ? res.json() : null))
      .then((data) => { if (data) renderCart(data, false); })
      .catch(() => {});
  }
  function lineError(key, msg) {
    $$('[data-c-line-qty][data-key="' + CSS.escape(key) + '"]').forEach((wrap) => {
      const line = wrap.closest('li') || wrap.parentElement;
      let el = $('[data-c-line-error]', line);
      if (!el) { el = document.createElement('p'); el.dataset.cLineError = ''; el.className = 'c-small c-accent c-form-err'; el.setAttribute('role', 'alert'); line.appendChild(el); }
      el.textContent = msg;
      const input = $('input', wrap);
      if (input && input.dataset.qty) input.value = input.dataset.qty; // tilbage til det antal, kurven faktisk har
    });
  }
  async function changeLine(key, quantity) {
    const panel = $('#c-cart [data-c-cart-inner]');
    panel && panel.setAttribute('aria-busy', 'true');
    try {
      await saveNote();
      const data = await post(routes.cartChange, { id: key, quantity, sections: [CART_SECTION], sections_url: window.location.pathname });
      if (document.body.classList.contains('c-tpl-cart')) { window.location.reload(); return; }
      renderCart(data.sections, false);
    } catch (err) {
      panel && panel.removeAttribute('aria-busy');
      lineError(key, errText(err, ERR_CART));
      if (!document.body.classList.contains('c-tpl-cart')) refreshCart().then(() => lineError(key, errText(err, ERR_CART)));
    }
  }
  document.addEventListener('click', (e) => {
    const step = e.target.closest('[data-c-line-qty] [data-step]');
    if (step) {
      const wrap = step.closest('[data-c-line-qty]');
      const input = $('input', wrap);
      const q = Math.max(0, Number(input.value) + Number(step.dataset.step));
      input.value = q;
      changeLine(wrap.dataset.key, q);
      return;
    }
    const rm = e.target.closest('[data-c-remove]');
    if (rm) { e.preventDefault(); changeLine(rm.dataset.key, 0); }
  });
  document.addEventListener('change', (e) => {
    const input = e.target.closest('[data-c-line-qty] input');
    if (input) changeLine(input.closest('[data-c-line-qty]').dataset.key, Math.max(0, Number(input.value) || 0));
  });

  /* ---------- antal på produktsiden ---------- */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-c-qty] [data-step]');
    if (!b) return;
    const input = $('input', b.closest('[data-c-qty]'));
    const max = Number(input.max) || Infinity;
    input.value = Math.min(max, Math.max(1, Number(input.value) + Number(b.dataset.step)));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- galleri ---------- */
  $$('[data-c-gallery]').forEach((g) => {
    const track = $('[data-c-gallery-track]', g);
    const thumbs = $$('[data-c-thumb]', g);
    if (!track) return;
    const slides = $$('[data-c-slide]', track);
    const prev = $('[data-c-gallery-step="-1"]', g);
    const next = $('[data-c-gallery-step="1"]', g);
    let current = 0;
    const setActive = (i) => {
      current = i;
      thumbs.forEach((t, n) => t.setAttribute('aria-current', n === i ? 'true' : 'false'));
      if (prev) prev.disabled = i <= 0;
      if (next) next.disabled = i >= slides.length - 1;
    };
    const go = (i) => {
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: 'smooth' });
      setActive(i);
    };
    thumbs.forEach((t, i) => t.addEventListener('click', () => go(i)));
    [prev, next].forEach((b) => b && b.addEventListener('click', () => go(current + Number(b.dataset.cGalleryStep))));
    setActive(0);
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => entries.forEach((en) => { if (en.isIntersecting && en.intersectionRatio > 0.6) setActive(slides.indexOf(en.target)); }), { root: track, threshold: [0.6] });
      slides.forEach((s) => io.observe(s));
    }
  });

  /* ---------- sticky køb ---------- */
  const sticky = $('[data-c-sticky-buy]');
  const mainBtn = $('[data-c-main-buy]');
  if (sticky && mainBtn && 'IntersectionObserver' in window) {
    // bjælken vises kun, når hverken købsknappen eller pakkevalgene kan ses, så den ikke dækker dem
    const packs = $('.c-pack');
    const seen = new Map();
    // det, der ligger under den faste header, tæller som ikke synligt
    const hdr = $('.c-header-section');
    const top = hdr && getComputedStyle(hdr).position === 'sticky' ? hdr.offsetHeight : 0;
    const io = new IntersectionObserver((entries) => {
      // købsknappen skal kunne ses helt; pakkevalgene er nok, når en del af dem kan ses
      entries.forEach((en) => seen.set(en.target, en.target === mainBtn ? en.intersectionRatio > 0.95 : en.isIntersecting));
      sticky.classList.toggle('is-visible', ![...seen.values()].some(Boolean));
    }, { rootMargin: '-' + top + 'px 0px 0px 0px', threshold: [0, 0.95, 1] });
    io.observe(mainBtn);
    if (packs) io.observe(packs);
  }

  /* ---------- korte videoer: afspil (hurtigere) når de er på skærmen ---------- */
  const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  $$('video[data-c-autoplay]').forEach((v) => {
    const rate = Number(v.dataset.rate) || 1;
    const setRate = () => { v.defaultPlaybackRate = rate; v.playbackRate = rate; };
    v.addEventListener('loadedmetadata', setRate);
    v.addEventListener('play', setRate);
    if (reduceMotion || !('IntersectionObserver' in window)) { v.controls = true; return; }
    new IntersectionObserver(([en]) => {
      if (en.isIntersecting) { setRate(); const p = v.play(); if (p && p.catch) p.catch(() => { v.controls = true; }); }
      else v.pause();
    }, { threshold: 0.25 }).observe(v);
  });

  /* ---------- kontakt og fortrydelse: behold det udfyldte, hvis Shopify afviser formularen ---------- */
  $$('form.c-form[id]').forEach((form) => {
    const key = 'c-form:' + form.id;
    form.addEventListener('submit', () => {
      try {
        const data = {};
        $$('[name^="contact["]', form).forEach((el) => { data[el.name] = el.type === 'checkbox' ? el.checked : el.value; });
        sessionStorage.setItem(key, JSON.stringify(data));
      } catch (_) {}
    });
    try {
      const saved = JSON.parse(sessionStorage.getItem(key) || 'null');
      if (saved && $('.c-form-msg--err', form)) {
        $$('[name^="contact["]', form).forEach((el) => {
          if (!(el.name in saved)) return;
          if (el.type === 'checkbox') el.checked = !!saved[el.name];
          else if (!el.value && el.type !== 'hidden') el.value = saved[el.name];
        });
      } else if (saved) sessionStorage.removeItem(key);
    } catch (_) {}
  });

  /* ---------- pakkevalg på produktsiden ---------- */
  function applyPack(r) {
    const wrap = r.closest('[data-c-product]');
    if (!wrap) return;
    const amount = $('[data-c-price-wrap] .c-price__amount', wrap);
    if (amount && r.dataset.price) amount.textContent = r.dataset.price;
    // førprisen (overstreget) følger det valgte pakkevalg
    const cmp = $('[data-c-price-wrap] .c-price__compare', wrap);
    if (cmp) { cmp.hidden = !r.dataset.compare; cmp.innerHTML = r.dataset.compare ? '<span class="visually-hidden">Før </span>' + r.dataset.compare : ''; }
    const pct = $('[data-c-price-wrap] .c-price__pct', wrap);
    if (pct) { pct.hidden = !r.dataset.pct; pct.textContent = r.dataset.pct || ''; }
    const sp = $('[data-c-sticky-price]');
    if (sp && r.dataset.price) sp.innerHTML = (r.dataset.compare ? '<s class="c-price__compare"><span class="visually-hidden">Før </span>' + r.dataset.compare + '</s> ' : '') + r.dataset.price;
    const st = $('[data-c-sticky-title]');
    if (st && r.dataset.title) st.textContent = r.dataset.title;
    // antal: må ikke overstige lageret for det valgte pakkevalg
    const qty = $('[data-c-qty] input', wrap);
    if (qty) {
      if (r.dataset.max) { qty.max = r.dataset.max; if (Number(qty.value) > Number(r.dataset.max)) qty.value = r.dataset.max; }
      else qty.removeAttribute('max');
    }
    // fragtlinjen: kun når kurven er tom, ellers styres den af kurven
    const hint = $('[data-c-ship-left]', wrap);
    if (hint && Number(hint.dataset.cart || 0) === 0 && r.dataset.cents) {
      const first = $('.c-pack input[type="radio"]', wrap);
      if (Number(r.dataset.cents) >= Number(hint.dataset.threshold)) { hint.textContent = 'Gratis fragt på ' + (r.dataset.shipName || 'denne pakke'); hint.hidden = false; }
      else if (r === first && hint.dataset.hint) { hint.textContent = hint.dataset.hint; hint.hidden = false; }
      else { hint.hidden = true; }
    }
    // lagerlinjen følger det valgte pakkevalg
    const stock = $('[data-c-stock]', wrap);
    if (stock && r.dataset.stock) stock.innerHTML = r.dataset.stock;
  }
  document.addEventListener('change', (e) => {
    const r = e.target.closest('.c-pack input[type="radio"]');
    if (r) applyPack(r);
  });
  // browseren kan genskabe et andet valg (tilbage-knap, genindlæsning), uden at der sker en change
  const syncPacks = () => $$('.c-pack input[type="radio"]:checked').forEach(applyPack);
  syncPacks();
  window.addEventListener('pageshow', (e) => {
    syncPacks();
    // siden kom fra browserens cache (tilbage-knap): hent kurven igen, så antal og indhold passer
    if (e.persisted) refreshCart();
  });

  /* ---------- forventet levering ---------- */
  $$('[data-c-eta]').forEach((el) => {
    const min = Number(el.dataset.min) || 1, max = Number(el.dataset.max) || 3;
    const closed = ['12-24', '12-25', '12-26', '12-31', '01-01'];
    const isOpen = (x) => { const wd = x.getDay(); const md = String(x.getMonth() + 1).padStart(2, '0') + '-' + String(x.getDate()).padStart(2, '0'); return wd !== 0 && wd !== 6 && !closed.includes(md); };
    const addWorkdays = (d, n) => { const x = new Date(d); while (n > 0) { x.setDate(x.getDate() + 1); if (isOpen(x)) n--; } return x; };
    const fmt = (d) => d.toLocaleDateString('da-DK', { weekday: 'short', day: 'numeric', month: 'short' }).replace(/\.$/, '');
    const now = new Date();
    el.textContent = `${fmt(addWorkdays(now, min))} til ${fmt(addWorkdays(now, max))}`;
  });
})();

/* ---------- kampagneskift: genindlæs, hvis siden blev lavet før et skift ---------- */
(function () {
  const C = window.Critical || {};
  if (!C.switches || !C.renderedAt) return;
  const now = Date.now();
  const passed = C.switches.filter((t) => t > C.renderedAt && t <= now);
  if (passed.length) {
    const key = 'c-switch-' + passed[passed.length - 1];
    try { if (!sessionStorage.getItem(key)) { sessionStorage.setItem(key, '1'); window.location.reload(); return; } } catch (e) {}
  }
  const next = C.switches.filter((t) => t > now).sort((a, b) => a - b)[0];
  if (next && next - now < 6 * 3600 * 1000) setTimeout(() => window.location.reload(), next - now + 2000);
})();

